module.exports = __webpack_public_path__ + "img/fr_success_7.1aee9753.png";